module.exports = __webpack_public_path__ + "static/media/docentes.7a09dc30.png";